"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const DivResizer_1 = __importDefault(require("./DivResizer"));
const SVGResizer_1 = __importDefault(require("./SVGResizer"));
function Resizer(props) {
    const { tag = 'div', ...resProps } = props;
    if (tag === 'div') {
        return (0, jsx_runtime_1.jsx)(DivResizer_1.default, { ...resProps });
    }
    else {
        return (0, jsx_runtime_1.jsx)(SVGResizer_1.default, { ...resProps });
    }
}
exports.default = Resizer;
